import { render, staticRenderFns } from "./TaskCard.vue?vue&type=template&id=afcaf8c2&scoped=true&"
import script from "./TaskCard.vue?vue&type=script&lang=ts&"
export * from "./TaskCard.vue?vue&type=script&lang=ts&"
import style0 from "../theme/plugins/themify-icons/themify-icons.css?vue&type=style&index=0&id=afcaf8c2&prod&scoped=true&lang=css&"
import style1 from "./TaskCard.vue?vue&type=style&index=1&id=afcaf8c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcaf8c2",
  null
  
)

export default component.exports